import { useEffect } from 'react';

import type { ActorRefFrom } from 'xstate';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { machine } from '../../machine';

import { updateDraft } from './api';

type ActorRefType = ActorRefFrom<typeof machine>;

export function useSubscribeToMachine(actorRef: ActorRefType): void {
	const { errorReporter } = useUtilityContext();
	useEffect(() => {
		const subscription = actorRef.subscribe((currentSnapshot) => {
			const { draft: currentDraft } = currentSnapshot.context;
			if (!currentDraft || !currentDraft.id) return;
			const { id, ...petitionDraft } = currentDraft;

			// Fire-and-forget: intentionally not awaiting the promise as updates should not block UI.
			void (async () => {
				try {
					await updateDraft(id, petitionDraft);
				} catch (error) {
					void errorReporter.report(new Error('SAP: Could not update draft', { cause: error }));
				}
			})();
		});
		return () => subscription.unsubscribe();
	}, [actorRef, errorReporter]);
}
